import * as React from "react";
import { component } from "Agile/Scripts/Common/Components/ComponentRegistration";
import { PivotItemContent } from "Agile/Scripts/Common/Components/PivotItemContent";
import { BacklogsHubConstants } from "Agile/Scripts/Generated/HubConstants";
import { getDefaultWebContext } from "VSS/Context";
import { IBacklogPivotContext } from "Agile/Scripts/BacklogsHub/BacklogHubContracts";
import { BacklogsAnalyticsView } from "./BacklogsAnalyticsView"
import { getLevelSelectorViewAction } from "Agile/Scripts/Common/ViewActions/BacklogLevelSelectorViewAction";
import { IPivotBarViewAction, PivotBarViewActionArea } from "VSSUI/PivotBar";
import { VssIconType } from "VSSUI/VssIcon";
import { HubViewActions } from "Agile/Scripts/Common/HubViewActions";
import { HubViewOptionKeys } from "VSSUI/Utilities/HubViewState";

/** Data passed from the backlog view to the individual pivots */
export interface IBacklogsAnalyticsPivotContext extends IBacklogPivotContext {
    /**  Name of the pivot */
    pivotName: string;
}

interface IBacklogAnalyticsPivotState{
    lastRefresh?: Date;

    /** Describes if page has finished initial load. */
    isDataReady: boolean;
}

@component("backlogs-analytics-pivot")
export class BacklogsAnalyticsPivot extends PivotItemContent<IBacklogsAnalyticsPivotContext, IBacklogAnalyticsPivotState> {


    constructor(props: IBacklogsAnalyticsPivotContext, context?: any) {
        super(props, context, BacklogsHubConstants.HUB_NAME, props.pivotName);
        this.state = {
            isDataReady: false
        };
    }

    public isDataReady(): boolean {
        return this.state.isDataReady;
    }

    public render(): JSX.Element {
        const reportSettings = {
            teamId: this.props.team.id,
            teamName: this.props.team.name,
            projectId: getDefaultWebContext().project.id,
            categoryReferenceName: this.props.currentBacklog.id,
            categoryName:this.props.currentBacklog.name,
            lastRefresh: this.state.lastRefresh,
            onLoadCompleted: this.onLoadCompleted,
            isFullScreen: this.props.viewOptions.getViewOption(HubViewOptionKeys.fullScreen), //Whenever the full screen state changes, we want to trigger a re-render and get a completion notification back to boards page framework
            telemetryProps: {
                parentPageName: "BacklogsHub",
                area: "Backlogs"
            }
        };

        return (
            <div className="backlogs-analytics-content analytics-report-container">
                {<BacklogsAnalyticsView {...reportSettings}/>}
            </div>
        );
    }

    public onRefreshClick = () : void => {
        this.setState({ lastRefresh: new Date() });
    }
    
    public onLoadCompleted = () : void => {
        this.setState({ isDataReady: true });
    }
    
    protected getViewActions(props: IBacklogPivotContext): IPivotBarViewAction[] {
        const viewActions =  [
            getLevelSelectorViewAction(
                props.visibleBacklogLevels,
                props.viewOptions,
                /* canSwitchLevels */ null,
                "Backlog",
                { iconName: "BacklogList", iconType: VssIconType.fabric },
            ),
            HubViewActions.getRefreshAction(this.onRefreshClick, PivotBarViewActionArea.farRight)
        ];
        return viewActions;
    }

    protected shouldUpdateViewActionsOnUpdate(nextProps: IBacklogsAnalyticsPivotContext, nextState: IBacklogAnalyticsPivotState): boolean {
        return true;
    }
}